export const tableschema2 = {
    name_table: 'Розділ II. Наявність дітей у групах і місць на кінець звітного року(Державна статистика)',
    titles:[
        "Усі види груп",
        "у тому числі санаторні групи",
        "з них для дітей з латентною туберкульозною інфекцією та вилікуваних від туберкульозу",
        "хронічними неспецифічними захворюваннями органів дихання",
        "захворюваннями серцево-судинної системи",
        "захворюваннями ендокринної системи",
        "хворобами органів травлення",
        "психоневрологічними захворюваннями",
        "іншими захворюваннями",
        "спеціальні групи",
        "з них для дітей з порушенням слуху",
        "мови",
        "зору",
        "інтелекту",
        "опорно-рухового апарату",
        "затримкою психічного розвитку",
        "інклюзивні групи",
        "групи короткотривалого перебування",
        "групи з цілодобовим перебуванням дітей"
      ],
    parts:[
        {title: "Кількість дітей, осіб", subtitle: "усього", fields:[
        "GRchild2001",
        "GRchild2101",
        "GRchild21011",
        "GRchild21021",
        "GRchild21031",
        "GRchild21041",
        "GRchild21051",
        "GRchild21061",
        "GRchild21071",
        "GRchild2201",
        "GRchild2211",
        "GRchild2221",
        "GRchild2231",
        "GRchild2241",
        "GRchild2251",
        "GRchild2261",
        "GRchild2301",
        "GRchild2401",
        "GRchild2501"]
        },{title: "Кількість дітей, осіб", subtitle: "з них у віці 3 роки і старше", fields:[
        "GRchild2002",
        "GRchild21002",
        "GRchild210012",
        "GRchild210022",
        "GRchild210032",
        "GRchild210042",
        "GRchild210052",
        "GRchild210062",
        "GRchild210072",
        "GRchild2202",
        "GRchild2212",
        "GRchild2222",
        "GRchild2232",
        "GRchild2242",
        "GRchild2252",
        "GRchild2262",
        "GRchild2302",
        "GRchild2402",
        "GRchild2502"]
        },{title: "Кількість груп, од", subtitle: "усього", fields:[
        "GRchild2003",
        "GRchild2103",
        "GRchild21013",
        "GRchild21023",
        "GRchild21033",
        "GRchild21043",
        "GRchild21053",
        "GRchild21063",
        "GRchild21073",
        "GRchild2203",
        "GRchild2213",
        "GRchild2223",
        "GRchild2233",
        "GRchild2243",
        "GRchild2253",
        "GRchild2263",
        "GRchild2303",
        "GRchild2403",
        "GRchild2503"]
        },{title: "Кількість груп, од", subtitle: "з них для дітей у віці 3 роки і старше", fields:[
        "GRchild2004",
        "GRchild2104",
        "GRchild21014",
        "GRchild21024",
        "GRchild21034",
        "GRchild21044",
        "GRchild21054",
        "GRchild21064",
        "GRchild21074",
        "GRchild2204",
        "GRchild2214",
        "GRchild2224",
        "GRchild2234",
        "GRchild2244",
        "GRchild2254",
        "GRchild2264",
        "GRchild2304",
        "GRchild2404",
        "GRchild2504"
        ]
        },{title: "Кількість місць, од", subtitle: "усього", fields:[
        "GRchild2005",
        "GRchild2105",
        "GRchild21015",
        "GRchild21025",
        "GRchild21035",
        "GRchild21045",
        "GRchild21055",
        "GRchild21065",
        "GRchild21075",
        "GRchild2205",
        "GRchild2215",
        "GRchild2225",
        "GRchild2235",
        "GRchild2245",
        "GRchild2255",
        "GRchild2265",
        "GRchild2305",
        "GRchild2405",
        "GRchild2505"
            ]
        },{title: "Кількість місць, од", subtitle: "з них для дітей у віці 3 роки і старше", fields:[
        "GRchild2006",
        "GRchild2106",
        "GRchild21016",
        "GRchild21026",
        "GRchild21036",
        "GRchild21046",
        "GRchild21056",
        "GRchild21066",
        "GRchild21076",
        "GRchild2206",
        "GRchild2216",
        "GRchild2226",
        "GRchild2236",
        "GRchild2246",
        "GRchild2256",
        "GRchild2266",
        "GRchild2306",
        "GRchild2406",
        "GRchild2506"
            ]
        }
    ],
    shorts:{
        titles:[
            "2000",
            "2100",
            "2110",
            "2120",
            "2130",
            "2140",
            "2150",
            "2160",
            "2170",
            "2200",
            "2210",
            "2220",
            "2230",
            "2240",
            "2250",
            "2260",
            "2300",
            "2400",
            "2500"
          ],
        parts:[
            "1",
            "2",
            "3",
            "4",
            "5",
            "6"
          ]
    }
};